import Stepper from "ds/components/Stepper";
import StepperHeader from "ds/components/Stepper/Header";
import StepperStep from "ds/components/Stepper/Step";
import StepperStepsGroup from "ds/components/Stepper/StepsGroup";
import useTypedContext from "hooks/useTypedContext";

import { ApiKeyCreateWizardContext } from "../context";

const ApiKeyCreateStepper = () => {
  const { steps, currentStep, setCurrentStep } = useTypedContext(ApiKeyCreateWizardContext);

  return (
    <Stepper>
      <StepperHeader>Follow the steps</StepperHeader>
      <StepperStepsGroup>
        {steps.map((item, index) => (
          <StepperStep
            key={item.step}
            active={item.step === currentStep}
            onClick={index < currentStep ? () => setCurrentStep(item.step) : undefined}
            disabled={index > currentStep}
          >
            {item.name}
          </StepperStep>
        ))}
      </StepperStepsGroup>
    </Stepper>
  );
};

export default ApiKeyCreateStepper;
